import { atom } from 'recoil';

export const isNewVendorTruckModalOpenAtom = atom<boolean>({
  key: 'isNewVendorTruckModalOpenAtom',
  default: false,
});
